
import { onMounted, toRefs, watch } from "vue";
import { Options, setup, Vue } from 'vue-class-component';
import { useStore } from "vuex";

@Options({})
export default class LoadingMask extends Vue {

  loadingWrapper = setup(() => {
    const store = useStore();
    const {globalLoading} = toRefs(store.state);

    watch(globalLoading, (cur, pre) => {
      //console.log("cur", cur);
      //console.log("pre", pre);
    })

    onMounted(()=>{

      //console.log("loadingMask mounted",globalLoading);
    })

    return {
      loadingFlag: globalLoading
    }
  })
}
